import wx from 'weixin-js-sdk'
import api from '../api/index.js'
import constants from './constants.js';
const doShare = function ({ shareInfo, callback }) {
	let time = new Date().getTime();
	let shareLink = shareInfo.link
	// if (shareLink.indexOf('?') > -1) {
	// 	shareInfo.link + '&t=' + time
	// } else {
	// 	shareInfo.link + '?t=' + time
	// }
	//分享朋友圈
	wx.updateTimelineShareData({
		// var link = 'http://wxshare.bijixia.com.cn/index.html';
		title: shareInfo.title,
		desc: shareInfo.desc,
		link: shareLink,
		imgUrl: shareInfo.imgUrl, // 自定义图标
		success: function () {
			typeof callback == 'function' && callback(shareInfo)
		},
	});
	//分享给好友
	wx.updateAppMessageShareData({
		title: shareInfo.title,
		desc: shareInfo.desc,
		link: shareLink,
		imgUrl: shareInfo.imgUrl, // 自定义图标
		success: function () {
			typeof callback == 'function' && callback(shareInfo)
		},
	});

	wx.onMenuShareTimeline({
		title: shareInfo.shareName,
		desc: shareInfo.shareDescription,
		link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		imgUrl: shareInfo.shareImage, // 自定义图标
		success: function () {
			// 用户点击了分享后执行的回调函数
			typeof callback == 'function' && callback(shareInfo)
		}
	})

	wx.onMenuShareAppMessage({
		title: shareInfo.shareName,
		desc: shareInfo.shareDescription,
		link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		imgUrl: shareInfo.shareImage, // 自定义图标
		success: function () {
			// 用户点击了分享后执行的回调函数
			typeof callback == 'function' && callback(shareInfo)
		}
	})

	wx.error(function () {
	});
}

const doGetGeo = function (callback) {
	wx.getLocation({
		type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
		success: function (res) {
			// let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
			// let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
			// let speed = res.speed; // 速度，以米/每秒计
			// let accuracy = res.accuracy; // 位置精度
			typeof callback == 'function' && callback(res)
		}
	});
}

export function wxConfig(callback) {
	try {
		let data = {
			url: window.location.href.split('#')[0],
			app: constants.appName
		}
		api.login.getWxConfig(data).then(res => {
			wx.config({
				beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
				debug: false,
				appId: res.data.appId, // 必填，企业微信的corpID
				timestamp: res.data.timestamp, // 必填，生成签名的时间戳
				nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
				signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
				jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'getLocation'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
				openTagList: ['wx-open-launch-app'],
			});
			wx.error(function (res) {
				// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中
				//查看，对于SPA可以在这里更新签名。
				// alert(JSON.stringify(res));
			});
			document.addEventListener('WeixinOpenTagsError', function (e) {
				// alert(JSON.stringify(e)); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
			});
			typeof callback == 'function' && callback()
		})
	}
	catch (e) {
		console.log('非微信')
	}

}
/**分享 */
// shareInfo = {
// 	title: titles[this.goodsType],
// 	desc: 'CEO的新商业学堂',
// 	link: window.location.href,
// 	imgUrl: this.constants.logo,
// }
export function wxShare({ shareInfo, callback }) {
	try {
		/**获取微信配置信息 */
		wx.ready(() => {
			doShare({ shareInfo, callback })
		});
	} catch (e) {
		console.log('非微信')
	}

}

/** 地理位置 */
export function wxGeoLocation(callback) {
	try {
		wx.ready(() => {
			doGetGeo(callback)
		})
	} catch (e) {
		console.log('非微信')
	}
}